// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__25p7x","name":"Header_name__1keW6","birthday":"Header_birthday__2pa7C","skeleton":"Header_skeleton__1X469"};